import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { fromServerDateTimeToLocalized } from './datetime-converter';
import { isDataExclusion } from '../../adjustment-type';

export class StartTimeColumn extends ProjectionGridBaseColumn {
  constructor(option) {
    const title = _TL_('Start time');

    super({
      title,
      name: 'StartTime',
      bodyClasses: ['cell-start-time'],
      i18n: option.i18n,
      property: 'StartDate',
      sortable: 'StartDate',
      helpId: isDataExclusion(option.adjustmentType) ? 'pop_BA_DataExclusions_StartTime' : 'pop_BA_SeasonalityAdjustments_StartTime',
      helpAriaLabel: option.i18n.getString(_TL_('Click to learn more about {{item}}'), { item: option.i18n.getString(title) }),
    });
  }

  template({ value }) {
    if (value) {
      return fromServerDateTimeToLocalized({
        serverDateTime: value,
        i18n: this.config.i18n,
      });
    }
    return '-';
  }
}

export class EndTimeColumn extends ProjectionGridBaseColumn {
  constructor(option) {
    const title = _TL_('End time');
    super({
      title,
      name: 'EndTime',
      bodyClasses: ['cell-end-time'],
      i18n: option.i18n,
      property: 'EndDate',
      sortable: 'EndDate',
      helpId: isDataExclusion(option.adjustmentType) ? 'pop_BA_DataExclusions_EndTime' : 'pop_BA_SeasonalityAdjustments_EndTime',
      helpAriaLabel: option.i18n.getString(_TL_('Click to learn more about {{item}}'), { item: option.i18n.getString(title) }),
    });
  }

  template({ value }) {
    if (value) {
      return fromServerDateTimeToLocalized({
        serverDateTime: value,
        i18n: this.config.i18n,
      });
    }
    return '-';
  }
}
